import { createAction, props } from '@ngrx/store';

export const setCorrelationID = createAction(
  '[Common] set CorrelationID',
  props<{
    correlationId: string | null;
  }>()
);
